import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { trackWhatsAppClick } from '@/lib/analytics';
import { useLocation } from 'wouter';

export default function WhatsAppBubble() {
  const [location] = useLocation();
  const isTourPage = location.startsWith('/tours/');

  // Create a pre-filled message for tour pages
  const message = isTourPage
    ? encodeURIComponent(`Hi, I'm viewing a safari on your website and would like to ask some questions: ${window.location.href}`)
    : encodeURIComponent("Hi, I'm interested in a safari with Ecoplace Tours!");

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <a
        href={`https://wa.me/256780628299?text=${message}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackWhatsAppClick(isTourPage ? 'Floating Bubble (Tour Inquiry)' : 'Floating Bubble')}
        className="flex items-center gap-2 bg-[#25D366] hover:bg-[#128C7E] text-white px-5 py-3 rounded-full shadow-lg hover:shadow-xl transition-all hover:scale-105 group"
        aria-label={isTourPage ? "Ask about this trip on WhatsApp" : "Chat with us on WhatsApp"}
      >
        <FontAwesomeIcon icon={faWhatsapp} className="h-5 w-5" />
        <span key={isTourPage ? 'tour-inquiry' : 'generic-chat'} className="font-semibold text-sm tracking-wide">
          {isTourPage ? "Ask About This Trip" : "Chat With Us"}
        </span>
      </a>
    </div>
  );
}